import type { TenantVendorConnection } from "../types/marketplace.types";

export function getLatestSignedTermsVersion(
  connection: TenantVendorConnection,
): number {
  if (connection.signatures.length === 0) return 0;
  return Math.max(...connection.signatures.map((s) => s.termsVersion));
}

export function connectionNeedsResign(connection: TenantVendorConnection): boolean {
  return connection.vendor.termsVersion > getLatestSignedTermsVersion(connection);
}
